<template>
  <AppHeader>Delivery Location</AppHeader>

  <div id="mapbox" style="min-height: 500px; max-width: 100%;"></div>
</template>

<script>
import { Geolocation } from '@capacitor/geolocation';
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import SetLocation from '@/utils/CustomerMapControl.js';

export default {
  name: 'ProfileMap',
  mixins: [ mixin ],
  components: { AppHeader },
  data() {
    return {
      map: null,
      marker: null,
      data: { latitude: 13.0747, longitude: 80.2165 },
    }
  },

  methods: {
    setupMap() {
      mapboxgl.accessToken = this.$store.state.mapboxKey;

      this.map = new mapboxgl.Map({
        container: 'mapbox',
        style: 'mapbox://styles/mapbox/satellite-streets-v11',
        center: [80.2165, 13.0747],
        zoom: 14,
      });

      this.marker = new mapboxgl.Marker({
          color: "#699543",
          draggable: true
        })
        .setLngLat([80.2165, 13.0747])
        .addTo(this.map);

      let geolocate = new mapboxgl.GeolocateControl({ positionOptions: { enableHighAccuracy: true } });

      geolocate.on('geolocate', pos => {
        this.marker.setLngLat([pos.coords.longitude, pos.coords.latitude]);
        this.map.setCenter([pos.coords.longitude, pos.coords.latitude]);
      });

      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.addControl(geolocate);
      this.map.addControl(new SetLocation(this.setLocation), 'bottom-right');
      this.map.on('click', e => this.marker.setLngLat([e.lngLat.lng, e.lngLat.lat]));

      this.checkPermission();
      this.getData();
    },

    getData() {
      this.request('GET', 'profile/location', {}, (resp) => {
        if (resp.success && resp.data.latitude != '0.00000000' && resp.data.longitude != '0.00000000') this.data = resp.data;

        this.marker.setLngLat([this.data.longitude, this.data.latitude]);
        this.map.setCenter([this.data.longitude, this.data.latitude]);
      });
    },

    setLocation() {
      if (!this.marker) {
        alert('Please click on the Map to set a Location');
        return;
      }
      let pos = this.marker.getLngLat();

      this.request('POST', 'profile/location', {latitude: pos.lat, longitude: pos.lng}, (resp) => {
        alert(resp.message);
      });
    },

    checkPermission() {
      Geolocation
        .checkPermissions()
        .then(e => {
          if (e.location != 'granted' && this.$store.state.platform != 'web') {
            Geolocation
              .requestPermissions('location')
              .then(this.getCurrentLocation)
              .catch(e => alert('Please check if GPS is turned On!'));
          } else {
            this.getCurrentLocation();
          }
        })
        .catch(e => alert('Please check if GPS is turned On!'));
    },

    getCurrentLocation() {
      Geolocation
        .getCurrentPosition({enableHighAccuracy: true})
        .then(pos => {
          this.map.setCenter([pos.coords.longitude, pos.coords.latitude]);
          this.marker.setLngLat([pos.coords.longitude, pos.coords.latitude]);
        })
        .catch(e => alert('Please check if GPS is turned On!'));
    },
  },

  mounted() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.setupMap();
  },

  unmounted() {
    this.map = null;
    this.marker = null;
  },
}
</script>
